module.exports = __webpack_public_path__ + "img/finexpert-group.6b9238bf.png";